import React, { useEffect, useState } from 'react';
import { Col, Row } from 'shards-react';
import SelectOrganization from '../../common/SelectOrganization';
import { useTranslation } from 'react-i18next';
import { useDispatch } from '../../../redux/store';
import { getConditionHistoryList, setOrganizationId } from '../../../redux/slices/approval';
import type { OrganizationType } from '../../../types/organization';

interface OrganizationFilterProps {
  selectedOrganizationId: number | undefined;
}

const OrganizationFilter = ({ selectedOrganizationId }: OrganizationFilterProps): React.ReactElement => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const optionsFilter = (options: OrganizationType[]): OrganizationType[] => options.filter((option) => !option.isTradingCompany);

  // SIDE EFFECT
  // ================================================================================

  // 確認用
  // useEffect(() => {
  // }, []);

  // idで可視制御を取得する
  useEffect(() => {
    dispatch(getConditionHistoryList(selectedOrganizationId));
  }, [selectedOrganizationId]);

  // EVENT HANDLER
  // ================================================================================

  const handleOrganizationChange = (org: OrganizationType | null): void => {
    // console.log(org);
    const id: number | undefined = org?.id;
    dispatch(setOrganizationId(id));
  };

  // VIEW
  // ================================================================================

  return (
    <Row className="mb-4">
      <Col md="3" sm="6">
        <SelectOrganization placeholder={t('dropdown.organization')} isClearable={true} onChange={handleOrganizationChange} optionsFilter={optionsFilter} />
      </Col>
    </Row>
  );
};

export default OrganizationFilter;
